import React from "react";
import cx from "classnames";
import { useHistory } from "react-router-dom";

import styles from "./MobileRewardsBanner.module.scss";
import RewardUpsellBanner from "./mobileRewardsBanner/RewardUpsellBanner";
import RewardsSummaryBanner from "./mobileRewardsBanner/RewardsSummaryBanner";

const MobileRewardsBanner = ({ loyalty }) => {
    const history = useHistory();

    return (
        <div
            onClick={() => history.push("/rewards")}
            role="button"
            style={{ cursor: "pointer" }}
        >
            <div className={cx(styles.container, "d-block d-lg-none")}>
                {loyalty.account ? (
                    <RewardsSummaryBanner loyalty={loyalty} />
                ) : (
                    <RewardUpsellBanner />
                )}
            </div>
        </div>
    );
};

export default MobileRewardsBanner;
